module.exports = __webpack_public_path__ + "static/media/bg@2x.c0cbef24.png";